import request from '@/services/axios'
import { getToken } from '@/utils/auth'

export const hasCouponPopupLogin = () => {
  const token = getToken()
  return token !== null && token !== undefined && String(token).trim() !== ''
}

// 获取用户优惠券弹窗
export const getCouponPopup = () => {
  if (!hasCouponPopupLogin()) {
    return Promise.resolve({
      code: 'SUCCESS',
      data: []
    })
  }

  return request.post('/api/coupon/popup', {
    params: {}
  })
}

// 我的优惠券分页
export const getUserCouponPage = (data: any) => {
  return request.post('/api/coupon/user/page', data)
}

// 查询充值项可用优惠券
export const getAvailableCoupon = ({ catalogCode }: { catalogCode?: string } = {}) => {
  return request.post('/api/coupon/available', {
    params: {
      catalogCode
    }
  })
}

// 优惠券领取中心分页
export const getCouponClaimCenterPage = ({ pageNo = 1, pageSize = 10 }: { pageNo?: number; pageSize?: number } = {}) => {
  return request.post('/api/coupon/claim-center/page', {
    params: {
      pageNo,
      pageSize
    }
  })
}

// 领取中心领取优惠券
export const claimCoupon = ({ couponId }: { couponId?: string | number } = {}) => {
  return request.post('/api/coupon/claim', {
    params: {
      couponId
    }
  })
}
